<template>
  <div class="home-page">
    <div class="monitors-sidebar">
        <router-link :to="{ name: 'monitors.new'}" class="new-monitor-button">
            <i class="fal fa-plus"></i> New monitor
        </router-link>

        <input v-if="monitors.length > 0" id="search" type="search" placeholder="🤔 Search monitors" v-model="query">

        <MonitorItem
          is="monitor-item"
          v-for="(monitor, index) in monitors"
          v-bind:data-index="index"
          v-bind:monitor="monitor"
          v-bind:key="monitor.id"></MonitorItem>

          <section class="empty-monitors empty" v-if="monitors.length == 0">
              <div class="empty-icon" style="">
                <img width="70px" src="https://emojipedia-us.s3.amazonaws.com/thumbs/240/apple/129/crying-face_1f622.png" />
              </div>
            <p class="empty-title h3">No monitors</p>
            <p class="empty-subtitle">Create a monitor and start tracking.</p>
          </section>
    </div>
    <div class="monitor-view">
      <transition name="fade" mode="out-in" >
        <router-view v-bind:key="$route.params.id"></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import API from "../api"
import MonitorItem from "../components/MonitorItem.vue"
import MonitorForm from "../components/MonitorForm.vue"

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'monitors-page',
  data () {
    return {
        query: '',
        loading: false,
    }
  },
  components: {
    MonitorItem, MonitorItem
  },
  watch: {
      // '$route'() { this.$store.dispatch('getAllMonitors') }
  },
  created() {
      // this.fetchLatestMonitors();
      this.$store.dispatch('getAllMonitors')
      // this.$store.dispatch('getAllNotificators')
  },
  computed:{
    ... mapGetters({
      monitors: 'allMonitors'
    }),
  },
  /*
    computed: {
        computedMonitorsList: function () {
            var vm = this
            return this.monitors.filter(function (item) {
                return item.URL.toLowerCase().indexOf(vm.query.toLowerCase()) !== -1
            })
        }
  },
  */
  methods: {
    beforeEnter: function (el) {
      el.style.opacity = 0
      el.style.height = 0
    },

    enter: function (el, done) {
      var delay = el.dataset.index * 150
      setTimeout(function () {
        Velocity(
          el.children[0],
          { opacity: 1 },
          { complete: done }
        )
      }, delay)
    },

    leave: function (el, done) {
      var delay = el.dataset.index * 150
      setTimeout(function () {
        Velocity(
          el.children[0],
          { opacity: 0, height: 0 },
          { complete: done }
        )
      }, delay)
    }
  }
}
</script>

<style lang="scss">
.home-page {
    display: flex;

    .monitors-sidebar {
        width: 430px;
        padding: 10px;
        position: relative;
        border-radius: 5px;

        #search {
          width: 100%;
          border-bottom: 2px solid #f4f6f8;
          border-radius: 0px;
          color: #000;
          padding: 8px 6px;
          text-align: center;
          background: #fff;
          border-top: none;
          border-right: none;
          border-left: none;

            &:focus {
                border-color: #30364a;
            }

          &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
              color: #bbb;
              opacity: 1; /* Firefox */
              font-weight: 300;
              font-size: 13px;
          }
        }

        .new-monitor-button {
            // width: 100%;
            // background: #32b643;
            // display: inline-block;
            // color: #fff;
            // text-align: center;
            // padding: 8px 0px;
            // margin: 9px 0px;
            // margin-top: 0;
            // position: relative;
            // box-shadow: 0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08);

            // white-space: nowrap;
            // border-radius: 4px;
            // font-weight: 300;
            // text-transform: uppercase;
            // letter-spacing: .025em;
            // text-decoration: none;
            // transition: all .15s ease;

            &:hover {
              box-shadow: 0 7px 14px rgba(50,50,93,.1), 0 3px 6px rgba(0,0,0,.08);
            }

            &:active {
              top: 2px;
            }
        }
    }

    .monitor-view {
        flex: 3;
    }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s
}

.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/pages/HomePage.vue